export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11303.4a3ea3bb.jpg";